import Vue from "vue";
import Vuex from "vuex";
import modules from "./modules";
import VueAxios from "vue-axios";
import axios from "axios";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const store = new Vuex.Store({
  state: {
    allPractices: [],
    selectedItem: {},
    prevSelectedItem: {},
    createdItem: "",
    deletedItem: "",
    currentCategory: {},
    currentUser: {},
    forms: [],
    activeField: [],
    activeTabForFields: "elements",
    currentPractice: {},
    currentPracticeData: {},
    currentCms: {},
    currentPcn: {},
    currentFormData: {},
    oldFormData: {},
    roles: [],
  },
  mutations: {
    updateAllPractices(state, allPractices) {
      state.allPractices = allPractices;
    },
    updateCreatedItem(state, createdItem) {
      state.createdItem = createdItem;
    },
    updateDeletedItem(state, deletedItem) {
      state.deletedItem = deletedItem;
    },
    updatePrevSelectedItem(state, prevSelectedItem) {
      state.prevSelectedItem = prevSelectedItem;
    },
    updateSelectedItem(state, selectedItem) {
      state.selectedItem = selectedItem;
    },
    updateCurrentUser(state, currentUser) {
      state.currentUser = currentUser;
    },
    updateRoles(state, roles) {
      state.roles = roles;
    },
    updateForms(state, forms) {
      state.forms = forms;
    },
    updateActiveField(state, activeField) {
      state.activeField = activeField;
    },
    updateActiveTabForFields(state, activeTabForFields) {
      state.activeTabForFields = activeTabForFields;
    },
    updateCurrentPractice(state, currentPractice) {
      state.currentPractice = currentPractice;
    },
    updateCurrentCategory(state, currentCategory) {
      state.currentCategory = currentCategory;
    },
    updateCurrentPracticeData(state, currentPracticeData) {
      state.currentPracticeData = currentPracticeData;
    },
    updateCurrentCms(state, currentCms) {
      state.currentCms = currentCms;
    },
    updateCurrentPcn(state, currentPcn) {
      state.currentPcn = currentPcn;
    },
    updateCurrentFormData(state, currentFormData) {
      state.currentFormData = currentFormData;
    },
    updateOldFormData(state, oldFormData) {
      state.oldFormData = oldFormData;
    },
  },
  getters: {
    allPractices: (state) => state.allPractices,
    currentCategory: (state) => state.currentCategory,
    createdItem: (state) => state.createdItem,
    deletedItem: (state) => state.deletedItem,
    prevSelectedItem: (state) => state.prevSelectedItem,
    selectedItem: (state) => state.selectedItem,
    currentUser: (state) => state.currentUser,
    roles: (state) => state.roles,
    currentPractice: (state) => state.currentPractice,
    currentPracticeData: (state) => state.currentPracticeData,
    currentCms: (state) => state.currentCms,
    currentPcn: (state) => state.currentPcn,
    currentFormData: (state) => state.currentFormData,
    oldFormData: (state) => state.oldFormData,
  },
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  // strict: process.env.NODE_ENV !== 'production',
  strict: false,
});

export default store;
